import { Box, Paper } from "@mui/material"
import { useParams } from "react-router-dom"

import PanelFilterList from "./PanelFilterList"
import PanelFilterDetail from "./PanelFilterDetails"

const StockScreener = () => {

	const { screenerId }			= useParams()

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', minWidth: '320px' }} elevation={1}>
			<Box margin={1} width={'100%'} sx={{overflowX: 'auto'}}>
				{ screenerId >= 0 ? (
					<PanelFilterDetail screenerId={screenerId} />
				):(
					<PanelFilterList />
				)}
			</Box>
		</Paper>
	)

}

export default StockScreener
